import React from 'react';
import LoadingAnimation from '../components/LoadingAnimation';

const LoadingPage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5' // Optional: light background
    }}>
      <LoadingAnimation />
    </div>
  );
};

export default LoadingPage;